import { useState } from "react";
import { Play, TrendingUp, ArrowRight } from "lucide-react";

const VIDEO_ID = "fPdIZw89XkI";

const CompPlanVideo = () => {
  const [playing, setPlaying] = useState(false);
  return (
    <section data-testid="home-compplan-section" className="my-12">
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#06264f] via-[#0a2a5e] to-[#00153F] border border-[#45A0EE]/25 p-6 sm:p-10">
        <div className="absolute -top-20 -right-16 w-72 h-72 rounded-full bg-[#F5B700]/20 blur-3xl pointer-events-none" />
        <div className="absolute -bottom-24 -left-16 w-72 h-72 rounded-full bg-[#80C753]/20 blur-3xl pointer-events-none" />
        <div className="relative text-center mb-7">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/15 px-4 py-1.5 mb-3">
            <TrendingUp className="h-4 w-4 text-[#80C753]" />
            <span className="text-white text-[11px] font-black uppercase tracking-[2px]">Plan de Compensación</span>
          </span>
          <h2 className="text-white font-black text-3xl sm:text-4xl lg:text-5xl leading-tight mb-3" style={{ fontFamily: "Poppins, sans-serif" }}>
            Así se <span className="text-[#F5B700]">gana</span> en Club Viajemos
          </h2>
          <p className="text-slate-300 text-base sm:text-lg max-w-2xl mx-auto">
            Mira el video y entiende en minutos cómo funcionan las comisiones, los niveles y los bonos.
          </p>
        </div>

        <div className="relative mx-auto w-full max-w-[900px]">
          <div className="relative w-full rounded-[20px] overflow-hidden shadow-[0_18px_50px_rgba(0,0,0,.4)] bg-black" style={{ aspectRatio: "16 / 9" }}>
            {playing ? (
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
                title="Plan de Compensación — Club Viajemos" frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen data-testid="home-compplan-iframe"
              />
            ) : (
              <button onClick={() => setPlaying(true)} className="group absolute inset-0 w-full h-full" aria-label="Reproducir video del plan de compensación" data-testid="home-compplan-play">
                <img src={`https://img.youtube.com/vi/${VIDEO_ID}/maxresdefault.jpg`} alt="Plan de Compensación"
                  className="absolute inset-0 w-full h-full object-cover"
                  onError={(e) => { e.currentTarget.src = `https://img.youtube.com/vi/${VIDEO_ID}/hqdefault.jpg`; }} />
                <span className="absolute inset-0 bg-black/25 group-hover:bg-black/15 transition-colors" />
                <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 rounded-full bg-[#FF6B4A] shadow-[0_8px_30px_rgba(255,107,74,.6)] flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Play className="h-9 w-9 text-white ml-1" fill="white" />
                </span>
              </button>
            )}
          </div>
        </div>

        <div className="relative text-center mt-8">
          <a href="/plandeagencias" data-testid="home-compplan-cta" className="inline-flex items-center justify-center gap-2 rounded-full bg-[#80C753] hover:bg-[#6fb045] text-[#00153F] font-black text-base px-8 py-4 transition-all hover:-translate-y-0.5">
            Ver planes y precios <ArrowRight className="h-5 w-5" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default CompPlanVideo;
